import { type AtlasGqlTableView } from 'types/atlas-graphql';

export type BladeCardAssetFilter = {
  key: string;
  value: [string];
};

export type MakeModel = {
  make?: string | null;
  model?: string | null;
};

const getMakeModel = (view: AtlasGqlTableView): { make?: string; model?: string } => {
  const make = view.filters.asset?.find(
    (filter: BladeCardAssetFilter) => filter.key === 'componentMake'
  )?.value?.[0];
  const model = view.filters.asset?.find(
    (filter: BladeCardAssetFilter) => filter.key === 'componentModel'
  )?.value?.[0];
  return { make, model };
};

export const getRelevantBladeCards = (
  views: AtlasGqlTableView[],
  existingMakeModels: MakeModel[]
): AtlasGqlTableView[] =>
  views.filter(view => {
    const { make, model } = getMakeModel(view);
    return (
      !!make &&
      !!model &&
      existingMakeModels.some(({ make: m, model: mo }) => m === make && mo === model)
    );
  });
